import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Footer, Header } from "./components";
import {
  AboutPage,
  BookingPage,
  ContactPage,
  DashboardPage,
  FaqPage,
  HomePage,
  NotFoundPage,
  PricingPage,
  ServicesPage,
} from "./pages";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo({ top: 0, behavior: "auto" }), [pathname]);
  return null;
}

export default function App() {
  const { pathname } = useLocation();
  const isDashboard = pathname === "/dashboard";

  return (
    <>
      {/* <ScrollToTop /> */}
      {!isDashboard && <Header />}
      <main className={isDashboard ? "app-main app-main--dashboard" : "app-main"}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!isDashboard && <Footer />}
    </>
  );
}
